import React, { useState } from 'react'
import '../About/About.scss'
import './WarehouseSectionC.scss'
import { Row, Col } from 'reactstrap'
import { Waypoint } from 'react-waypoint'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import classNames from 'classnames'

const WarehouseSectionC = ({ data }) => {
  const [warehouseTextVisible, setWarehouseTextVisible] = useState(false)

  return (
    <section className="container-fluid about-warehouse-section-wrapper-C">
      <Row className="about-warehouse-section-C">
        <Col className="about-warehouse-title-text-C">
          <Waypoint onEnter={() => setWarehouseTextVisible(true)} bottomOffset="20%" />
          <div className={classNames('about-warehouse-title-C', { inRange: warehouseTextVisible })}>
            {data.title}
          </div>
          <div className={classNames('about-warehouse-text-C', { inRange: warehouseTextVisible })}>
            {documentToReactComponents(data.textOne)}
            <div
              className={classNames('about-warehouse-text-two-C', {
                inRange: warehouseTextVisible,
              })}
            >
              {documentToReactComponents(data.textTwo)}
            </div>
          </div>
        </Col>
        <Col className="about-warehouse-image-wrapper-C px-0">
          <img
            className={classNames('about-warehouse-image-C', { inRange: warehouseTextVisible })}
            src={data.image.fields.file.url}
            alt={data.image.fields.title}
            loading="lazy"
          />
        </Col>
      </Row>
    </section>
  )
}

export default WarehouseSectionC
